import { FC, useMemo, useState } from "react";

import Button from "../Button";
import Text from "../Text";

import React from "react";
import Skeleton from "react-loading-skeleton";
import Colors from "~/constants/colors";
import { PATH } from "~/constants/enum";
import { CartItem } from "~/services/cart";
import { formatNumber } from "~/utils/number";
import Divider from "../Divider";
import PaymentStripe from "../PaymentStripe";
import QuickCartMiniItem from "./Item/QuickCartMiniItem";
import Link from "next/link";
import classNames from "classnames";
import { isUsingLayoutV2 } from "~/utils/theme";

interface QuickCartProps {
  items?: CartItem[];
  loading?: boolean;
  subtotal?: number;
  total?: number;
  discount?: number;
}

const QuickCartMini: FC<QuickCartProps> = ({
  items,
  loading,
  subtotal,
  discount,
  total,
}) => {
  const [idDeleting, setIdDeleting] = useState<string>();

  // const subtotal =
  //     items
  //         ?.map((item) => {
  //             const finalPrice = item.selectedVariant?.product?.price_range?.minimum_price?.final_price?.value || 0;
  //             const quantity = item.quantity || 1;

  //             return finalPrice * quantity;
  //         })
  //         .reduce((sum, item) => sum + item, 0) || 0;

  const products = useMemo(() => {
    if (loading) return Array.from({ length: 2 }).map((_, i) => i) as any[];
    return items;
  }, [items, loading]);

  return (
    <div
      className={classNames("bg-white shadow-xl border", {
        "rounded-xl": !isUsingLayoutV2,
      })}
    >
      <div
        className={classNames("bg-secondary p-4", {
          "rounded-t-xl": !isUsingLayoutV2,
          "text-white": isUsingLayoutV2,
        })}
        style={{
          background: isUsingLayoutV2 ? Colors.PRIMARY : Colors.PRIMARY_LIGHT,
        }}
      >
        <Text type="title-5">
          Cart ({items?.length} item{Number(items?.length) > 1 ? "s" : ""})
        </Text>
      </div>
      <div className="flex flex-col gap-6 w-[350px] max-h-[350px] overflow-auto p-4 pr-6 overscroll-contain">
        {products?.map((i, index: number) => {
          return (
            <React.Fragment key={index}>
              <QuickCartMiniItem
                cartItem={i}
                loading={loading}
                setIdDeleting={setIdDeleting}
                idDeleting={idDeleting}
              />
            </React.Fragment>
          );
        })}
      </div>
      <Divider />
      <div className="p-4">
        <div className="flex justify-between mb-2">
          <Text type="title-4">Total:</Text>
          <Text type="title-4" className="text-primary">
            {loading ? (
              <Skeleton className="w-[80px]" />
            ) : (
              <>${formatNumber(subtotal, 2)}</>
            )}
          </Text>
        </div>
        <div className="flex justify-center flex-col gap-1">
          {total && total > 0 && (
            <div className="w-full">
              <PaymentStripe />
            </div>
          )}
          <a
            href={PATH.Carts}
            className="w-full"
            onClick={(e) => loading && e.preventDefault()}
          >
            <Button
              className="w-full "
              // variant="secondary"
              type="outline"
              variant="secondary"
              disabled={loading}
            >
              View cart & check out
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default QuickCartMini;
